import {
    CLIENT_BRANCH_LIST_REQUEST,
    CLIENT_BRANCH_LIST_SUCCESS,
    CLIENT_BRANCH_LIST_FAILURE
} from "../../actions/types"

// reducer.js
const initialState = {
    isLoading: false,
    response: null,
    error: null
};

export const clientBranchListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CLIENT_BRANCH_LIST_REQUEST:
            return { ...state, isLoading: true, response: null, error: null };
        case CLIENT_BRANCH_LIST_SUCCESS:
            return { ...state, isLoading: false, response: action.payload, error: null };
        case CLIENT_BRANCH_LIST_FAILURE:
            return { ...state, isLoading: false, response: null, error: action.payload };
        default:
            return state;
    }
};